import Modal from './Modal';
import { Hl7Log } from 'src/shared/types';

type Hl7LogDetailModalProps = {
  log: Hl7Log | null;
  onClose: () => void;
};

const Hl7LogDetailModal = ({ log, onClose }: Hl7LogDetailModalProps) => {
  if (!log) return null;

  const hasParsedAck = log.ack_code != null || log.ack_http_status != null;

  return (
    <Modal title={`HL7 Log`} onClose={onClose}>
      <div className="space-y-6">
        <section>
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider mb-2">Raw Message</h3>
          <pre className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-xs overflow-x-auto max-h-48 overflow-y-auto whitespace-pre-wrap break-all">
            {log.outgoing_message}
          </pre>
        </section>
        <section>
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider mb-2">Raw ACK Message</h3>
          <pre className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-xs overflow-x-auto max-h-48 overflow-y-auto whitespace-pre-wrap break-all">
            {log.raw_ack || 'No ACK received'}
          </pre>
        </section>
        <section>
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wider mb-2">Parsed ACK Message</h3>
          {hasParsedAck ? (
            <dl className="bg-gray-50 border border-gray-200 rounded-lg divide-y divide-gray-200">
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">HTTP Status</dt>
                <dd className="text-sm font-medium text-gray-900">{log.ack_http_status ?? '—'}</dd>
              </div>
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">ACK Code</dt>
                <dd className="text-sm font-medium text-gray-900">{log.ack_code || '—'}</dd>
              </div>
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">Accepted</dt>
                <dd className="text-sm font-medium text-gray-900">{log.ack_accepted == null ? '—' : log.ack_accepted ? 'Yes' : 'No'}</dd>
              </div>
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">ACK Control ID</dt>
                <dd className="text-sm font-medium text-gray-900 break-all">{log.ack_control_id || '—'}</dd>
              </div>
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">ACK Text</dt>
                <dd className="text-sm font-medium text-gray-900">{log.ack_text || '—'}</dd>
              </div>
              <div className="px-4 py-2 flex justify-between gap-4">
                <dt className="text-sm text-gray-500">Error Segment</dt>
                <dd className="text-sm font-medium text-gray-900">{log.ack_err_segment || '—'}</dd>
              </div>
            </dl>
          ) : (
            <p className="text-sm text-gray-500">No parsed ACK data</p>
          )}
        </section>
      </div>
    </Modal>
  );
};

export default Hl7LogDetailModal;
